module.exports = __webpack_public_path__ + "img/show.26a5d49f.svg";